export const GET_ORGANIZATION_AVAILABLE_PATH: string = '/organization/available';
